module.exports = __webpack_public_path__ + "static/media/p3.0d041c58.png";